export const PAYERS_FALLBACK_LIST = [
  {
    payerId: 'VTX0000',
    payerName: 'SENTINEL MANAGEMENT SERVICES'
  },
  {
    payerId: 'VTX0001',
    payerName: 'MEDIGOLD HEALTH PLANS'
  },
  {
    payerId: 'VTX0002',
    payerName: 'MEDICAID PENNSYLVANIA'
  },
  {
    payerId: 'VTX0003',
    payerName: 'PEOPLES HEALTH'
  },
  {
    payerId: 'VTX0004',
    payerName: 'FIRST UNITED AMERICAN INSURANCE COMPANY'
  },
  {
    payerId: 'VTX0005',
    payerName: 'CARESOURCE OF INDIANA'
  },
  {
    payerId: 'VTX0006',
    payerName: 'SENIOR HLTH COMPANY'
  },
  {
    payerId: 'VTX0007',
    payerName: 'SECURE HEALTH PLANS OF GEORGIA'
  },
  {
    payerId: 'VTX0008',
    payerName: 'GOLDEN RULE'
  },
  {
    payerId: 'VTX0009',
    payerName: 'WORLD CORP'
  },
  {
    payerId: 'VTX0010',
    payerName: 'UNIVERA'
  },
  {
    payerId: 'VTX0011',
    payerName: 'HOME STATE HEALTH PLAN'
  },
  {
    payerId: 'VTX0012',
    payerName: 'ADMINISTRATIVE SERVICES INC'
  },
  {
    payerId: 'VTX0013',
    payerName: 'TIME INSURANCE COMPANY ASSURANCE HEALTH'
  },
  {
    payerId: 'VTX0014',
    payerName: 'GEMCARE'
  },
  {
    payerId: 'VTX0015',
    payerName: 'HEALTHSMART BENEFIT SOLUTIONS'
  },
  {
    payerId: 'VTX0016',
    payerName: 'THE ULLICO FAMILY OF COMPANIES'
  },
  {
    payerId: 'VTX0017',
    payerName: 'MEDICAID NEWYORK'
  },
  {
    payerId: 'VTX0018',
    payerName: 'PITTMAN AND ASSOCIATES'
  },
  {
    payerId: 'VTX0019',
    payerName: "TODAY'S HEALTH"
  },
  {
    payerId: 'VTX0020',
    payerName: 'CAPITOL ADMINISTRATORS'
  },
  {
    payerId: 'VTX0021',
    payerName: 'LEON MEDICAL CENTERS HEALTH PLAN'
  },
  {
    payerId: 'VTX0022',
    payerName: 'KAISER FOUNDATION HEALTH PLAN OF HAWAII'
  },
  {
    payerId: 'VTX0023',
    payerName: 'WELL SENSE'
  },
  {
    payerId: 'VTX0024',
    payerName: 'COLONIAL PENN LIFE'
  },
  {
    payerId: 'VTX0025',
    payerName: 'GLOBE LIFE AND ACCIDENT INSURANCE COMPANY'
  },
  {
    payerId: 'VTX0026',
    payerName: 'GRANITE STATE HEALTH PLAN'
  },
  {
    payerId: 'VTX0027',
    payerName: 'AETNA BETTER HEALTH'
  },
  {
    payerId: 'VTX0028',
    payerName: 'AMERICAN NATIONAL INSURANCE COMPANY'
  },
  {
    payerId: 'VTX0029',
    payerName: 'ULTIMATE HEALTH PLANS'
  },
  {
    payerId: 'VTX0030',
    payerName: 'SENIOR HEALTH SERVICES CENTER-UAFC'
  },
  {
    payerId: 'VTX0031',
    payerName: 'MOLINA HEALTHCARE ILLINOIS'
  },
  {
    payerId: 'VTX0032',
    payerName: 'GOLDEN TRIANGLE PHYSICIAN ALLIANCE'
  },
  {
    payerId: 'VTX0033',
    payerName: 'FIDELIS CARE NEW YORK'
  },
  {
    payerId: 'VTX0034',
    payerName: 'OHANA HEALTH PLAN'
  },
  {
    payerId: 'VTX0035',
    payerName: 'MEDICAID ILLINOIS'
  },
  {
    payerId: 'VTX0036',
    payerName: 'SCAN HMO CALIFORNIA'
  },
  {
    payerId: 'VTX0037',
    payerName: 'J F MALLOY AND ASSOCIATES'
  },
  {
    payerId: 'VTX0038',
    payerName: 'PREFERRED HEALTH SYSTEMS'
  },
  {
    payerId: 'VTX0039',
    payerName: 'WISCONSIN CHRONIC DISEASE PROGRAM'
  },
  {
    payerId: 'VTX0040',
    payerName: 'AFFINITY HEALTH PLAN'
  },
  {
    payerId: 'VTX0041',
    payerName: 'MUNICIPAL HEALTH BENEFIT FUND'
  },
  {
    payerId: 'VTX0042',
    payerName: 'MMSI'
  },
  {
    payerId: 'VTX0043',
    payerName: 'EMPLOYERS HEALTH COALITION (HEALTHSCOPE)'
  },
  {
    payerId: 'VTX0044',
    payerName: 'CORESOURCE LITTLE ROCK'
  },
  {
    payerId: 'VTX0045',
    payerName: 'CALOPTIMA'
  },
  {
    payerId: 'VTX0046',
    payerName: 'SAMBA HEALTH BENEFIT PLAN'
  },
  {
    payerId: 'VTX0047',
    payerName: 'SELECTHEALTH'
  },
  {
    payerId: 'VTX0048',
    payerName: 'HEALTHPLUS OF MICHIGAN'
  },
  {
    payerId: 'VTX0049',
    payerName: 'JOHN ALDEN LIFE INSURANCE COMPANY ASSURANT HEALTH'
  },
  {
    payerId: 'VTX0050',
    payerName: 'UNIVERSITY PHYSICIANS HEALTHCARE GROUP ARIZONA'
  },
  {
    payerId: 'VTX0051',
    payerName: 'MEDICAID NEW MEXICO'
  },
  {
    payerId: 'VTX0052',
    payerName: 'WELLS FARGO THIRD PARTY ADMINISTRATORS INC'
  },
  {
    payerId: 'VTX0053',
    payerName: 'CENTRAL STATES FUND'
  },
  {
    payerId: 'VTX0054',
    payerName: 'UNIVERSITY PHYSICIANS CARE ADVANTAGE ARIZONA'
  },
  {
    payerId: 'VTX0055',
    payerName: 'SCHALLER ANDERSON DELEWARE PHYSICIANS CARE'
  },
  {
    payerId: 'VTX0056',
    payerName: 'SUSQUEHANNA TRANSIT COMPANY'
  },
  {
    payerId: 'VTX0057',
    payerName: 'VALLEY HEALTH PLAN'
  },
  {
    payerId: 'VTX0058',
    payerName: 'CENTRAL SENIOR CARE'
  },
  {
    payerId: 'VTX0059',
    payerName: 'SUNFLOWER STATE HEALTH PLAN'
  },
  {
    payerId: 'VTX0060',
    payerName: 'WESTERN HEALTH ADVANTAGE (5010)'
  },
  {
    payerId: 'VTX0061',
    payerName: 'AMERICAN REPUBLIC INSURANCE'
  },
  {
    payerId: 'VTX0062',
    payerName: 'MEDICAL MUTUAL'
  },
  {
    payerId: 'VTX0063',
    payerName: 'UNITEDHEALTHCARE'
  },
  {
    payerId: 'VTX0064',
    payerName: 'MEDICAID SOUTH DAKOTA'
  },
  {
    payerId: 'VTX0065',
    payerName: 'MOLINA HEALTHCARE CALIFORNIA'
  },
  {
    payerId: 'VTX0066',
    payerName: 'GROUP PRACTICE AFFILIATES'
  },
  {
    payerId: 'VTX0067',
    payerName: 'HEALTHSPRING'
  },
  {
    payerId: 'VTX0068',
    payerName: 'COOPERATIVE BENEFIT ADMINISTRATORS'
  },
  {
    payerId: 'VTX0069',
    payerName: 'WEA TRUST'
  },
  {
    payerId: 'VTX0070',
    payerName: 'USAA LIFE INSURANCE COMPANY'
  },
  {
    payerId: 'VTX0071',
    payerName: 'PINNACLE PHYSICIAN MANAGEMENT ORG'
  },
  {
    payerId: 'VTX0072',
    payerName: "CHILDREN'S MERCY PCN"
  },
  {
    payerId: 'VTX0073',
    payerName: 'TRICARE CHAMPUS'
  },
  {
    payerId: 'VTX0074',
    payerName: 'PACIFICARE OF WASHINGTON'
  },
  {
    payerId: 'VTX0075',
    payerName: 'SENIOR WHOLE HEALTH'
  },
  {
    payerId: 'VTX0076',
    payerName: 'KAISER PERMANENTE - KPIC'
  },
  {
    payerId: 'VTX0077',
    payerName: 'PRIORITY HEALTH'
  },
  {
    payerId: 'VTX0078',
    payerName: 'NOVA HEALTH ADMINISTRATORS'
  },
  {
    payerId: 'VTX0079',
    payerName: 'MANAGED HEALTH SERVICES WISCONSIN'
  },
  {
    payerId: 'VTX0080',
    payerName: 'TEXANPLUS (INTEGRANET)'
  },
  {
    payerId: 'VTX0081',
    payerName: 'INLAND EMPIRE HEALTH'
  },
  {
    payerId: 'VTX0082',
    payerName: 'PIEDMONT WELLSTAR HEALTHPLANS'
  },
  {
    payerId: 'VTX0083',
    payerName: 'SELECTCARE OF TEXAS INTEGRANET'
  },
  {
    payerId: 'VTX0084',
    payerName: 'USAA MEDICARE SUPPLEMENTAL'
  },
  {
    payerId: 'VTX0085',
    payerName: 'BLUE SHIELD OF CALIFORNIA'
  },
  {
    payerId: 'VTX0086',
    payerName: 'ORANGE COUNTY FIRE AUTHORITY'
  },
  {
    payerId: 'VTX0087',
    payerName: 'SCHALLER ANDERSON MAJESTACARE VA'
  },
  {
    payerId: 'VTX0088',
    payerName: 'BLUE BENEFIT ADMINISTRATORS OF MASSACHUSETTS'
  },
  {
    payerId: 'VTX0089',
    payerName: 'LOUISIANA HEALTHCARE CONNECTIONS'
  },
  {
    payerId: 'VTX0090',
    payerName: 'CAREPLUS'
  },
  {
    payerId: 'VTX0091',
    payerName: 'STEWART C MILLER AND CO'
  },
  {
    payerId: 'VTX0092',
    payerName: 'SCHALLER ANDERSON TEXAS CHRISTUS'
  },
  {
    payerId: 'VTX0093',
    payerName: 'AMERICAN FAMILY LIFE ASSURANCE CO AFLAC'
  },
  {
    payerId: 'VTX0094',
    payerName: 'MOLINA HEALTHCARE NEW MEXICO'
  },
  {
    payerId: 'VTX0095',
    payerName: 'MARICOPA CARE ADVANTAGE ARIZONA'
  },
  {
    payerId: 'VTX0096',
    payerName: 'SCOTT AND WHITE HEALTH PLAN'
  },
  {
    payerId: 'VTX0097',
    payerName: 'BRIDGESTONE AMERICAS INC'
  },
  {
    payerId: 'VTX0098',
    payerName: 'CHRISTIAN BROTHERS SERVICES'
  },
  {
    payerId: 'VTX0099',
    payerName: 'MEDSTAR FAMILY CHOICE'
  },
  {
    payerId: 'VTX0100',
    payerName: 'VILLAGE FAMILY PRATICE'
  },
  {
    payerId: 'VTX0101',
    payerName: 'TEXAN PLUS INTEGRANET'
  },
  {
    payerId: 'VTX0102',
    payerName: 'HEALTH CHOICE OF ARIZONA'
  },
  {
    payerId: 'VTX0103',
    payerName: 'SOUNDPATH HEALTH'
  },
  {
    payerId: 'VTX0104',
    payerName: 'JMH HEALTH PLAN FLORIDA'
  },
  {
    payerId: 'VTX0105',
    payerName: 'CARESOURCE (FHM)'
  },
  {
    payerId: 'VTX0106',
    payerName: 'PENN TREATY LIFE INSURANCE (CHCS SERVICES)'
  },
  {
    payerId: 'VTX0107',
    payerName: 'AMERICAN RETIREMENT LIFE INSURANCE COMPANY MEDICA'
  },
  {
    payerId: 'VTX0108',
    payerName: 'BETTER HEALTH'
  },
  {
    payerId: 'VTX0109',
    payerName: 'PANAMERICAN LIFE PUERTO RICO (PALIC)'
  },
  {
    payerId: 'VTX0110',
    payerName: 'HEALTH ALLIANCE PLAN'
  },
  {
    payerId: 'VTX0111',
    payerName: 'PROMINA ASO FORMERLY HEALTHCARE INC'
  },
  {
    payerId: 'VTX0112',
    payerName: 'LIFEWISE HEALTH PLAN OF OREGON'
  },
  {
    payerId: 'VTX0113',
    payerName: 'STERLING INVESTORS LIFE INSURANCE'
  },
  {
    payerId: 'VTX0114',
    payerName: 'MOLINA HEALTHCARE OF WISCONSIN'
  },
  {
    payerId: 'VTX0115',
    payerName: 'UNIVERSITY OF MISSOURI'
  },
  {
    payerId: 'VTX0116',
    payerName: 'ASSOCIACION DE MAESTROS PUERTO RICO'
  },
  {
    payerId: 'VTX0117',
    payerName: 'SANFORD HEALTH PLAN'
  },
  {
    payerId: 'VTX0118',
    payerName: 'FREEDOM BLUE'
  },
  {
    payerId: 'VTX0119',
    payerName: 'STATE MUTUAL MED SUPP.'
  },
  {
    payerId: 'VTX0120',
    payerName: 'AMERIGROUP CORPORATION'
  },
  {
    payerId: 'VTX0121',
    payerName: 'VNS CHOICE MEDICARE'
  },
  {
    payerId: 'VTX0122',
    payerName: 'IDEAL LIFE INSURANCE'
  },
  {
    payerId: 'VTX0123',
    payerName: 'MEDICAID HAWAII'
  },
  {
    payerId: 'VTX0124',
    payerName: 'PHYSICIANS MUTUAL'
  },
  {
    payerId: 'VTX0125',
    payerName: 'VA FEE BASIS PROGRAM'
  },
  {
    payerId: 'VTX0126',
    payerName: 'GATEWAY HEALTH PLAN'
  },
  {
    payerId: 'VTX0127',
    payerName: 'CIGNA'
  },
  {
    payerId: 'VTX0128',
    payerName: 'ESSENCE HEALTHCARE'
  },
  {
    payerId: 'VTX0129',
    payerName: 'TEXANPLUS (KELSEY-SEYBOLD)'
  },
  {
    payerId: 'VTX0130',
    payerName: 'TUFTS HEALTH PLAN'
  },
  {
    payerId: 'VTX0131',
    payerName: 'NETWORK HEALTH PLAN'
  },
  {
    payerId: 'VTX0132',
    payerName: 'BRAVO HEALTH INC'
  },
  {
    payerId: 'VTX0133',
    payerName: 'CHAMP VA'
  },
  {
    payerId: 'VTX0134',
    payerName: 'FIDELIS SECURECARE OF MICHIGAN'
  },
  {
    payerId: 'VTX0135',
    payerName: 'BENEFIT MANAGEMENT INC'
  },
  {
    payerId: 'VTX0136',
    payerName: 'MAGNOLIA HEALTH PLAN'
  },
  {
    payerId: 'VTX0137',
    payerName: 'TODAYS OPTIONS'
  },
  {
    payerId: 'VTX0138',
    payerName: 'MEDICAID OKLAHOMA'
  },
  {
    payerId: 'VTX0139',
    payerName: 'MEDICAID KANSAS'
  },
  {
    payerId: 'VTX0140',
    payerName: 'OK EMPLOYEES GROUP INSURANCE DIVISION HEALTHCHOICE'
  },
  {
    payerId: 'VTX0141',
    payerName: 'HEALTHEASE KIDS'
  },
  {
    payerId: 'VTX0142',
    payerName: 'KAISER FOUNDATION NORTHWEST'
  },
  {
    payerId: 'VTX0143',
    payerName: 'ALLEGIANCE BENEFIT PLAN MANAGEMENT'
  },
  {
    payerId: 'VTX0144',
    payerName: 'MUTUAL HEALTH SERVICES'
  },
  {
    payerId: 'VTX0145',
    payerName: 'CHP DIRECT'
  },
  {
    payerId: 'VTX0146',
    payerName: 'CORESOURCE (MD PA & IL)'
  },
  {
    payerId: 'VTX0147',
    payerName: 'MICHIGAN MICHILD'
  },
  {
    payerId: 'VTX0148',
    payerName: 'MEDBEN'
  },
  {
    payerId: 'VTX0149',
    payerName: 'FIRST MEDICAL NETWORK'
  },
  {
    payerId: 'VTX0150',
    payerName: 'BLUEGRASS FAMILY HEALTH'
  },
  {
    payerId: 'VTX0151',
    payerName: 'PACIFICARE OF ARIZONA'
  },
  {
    payerId: 'VTX0152',
    payerName: 'HEALTHPLAN OF NEVADA'
  },
  {
    payerId: 'VTX0153',
    payerName: 'UNIVERSITY OF ARIZONA HEALTH PLAN - UHM'
  },
  {
    payerId: 'VTX0154',
    payerName: 'ROCKY MOUNTAIN HMO COLORADO'
  },
  {
    payerId: 'VTX0155',
    payerName: 'KSKJ LIFE'
  },
  {
    payerId: 'VTX0156',
    payerName: 'WORLD INSURANCE COMPANY'
  },
  {
    payerId: 'VTX0157',
    payerName: 'MOLINA HEALTHCARE WASHINGTON'
  },
  {
    payerId: 'VTX0158',
    payerName: 'PINNACLE PHYSICIAN MANAGEMENT ORG'
  },
  {
    payerId: 'VTX0159',
    payerName: 'CENTRAL CALIFORNIA ALLIANCE FOR HEALTH'
  },
  {
    payerId: 'VTX0160',
    payerName: 'PREFERRED MEDICARE CHOICE PMC'
  },
  {
    payerId: 'VTX0161',
    payerName: 'MDWISE HOOSIER ALLIANCE'
  },
  {
    payerId: 'VTX0162',
    payerName: 'PRESTIGE HEALTH CHOICE'
  },
  {
    payerId: 'VTX0163',
    payerName: 'KAISER FOUNDATION OF CO'
  },
  {
    payerId: 'VTX0164',
    payerName: 'MANAGED HEALTH SERVICES INDIANA'
  },
  {
    payerId: 'VTX0165',
    payerName: 'AUTOMATED BENEFIT SERVICES'
  },
  {
    payerId: 'VTX0166',
    payerName: 'ANTARES MANAGEMENT SOLUTIONS'
  },
  {
    payerId: 'VTX0167',
    payerName: 'SCHALLER ANDERSON MISSOURI CARE'
  },
  {
    payerId: 'VTX0168',
    payerName: 'CENPATICO BEHAVIORAL HEALTH'
  },
  {
    payerId: 'VTX0169',
    payerName: 'HARKEN HEALTH'
  },
  {
    payerId: 'VTX0170',
    payerName: 'UNIVERSAL AMERICAN'
  },
  {
    payerId: 'VTX0171',
    payerName: 'GOVERNMENT EMPLOYEES HOSPITAL ASSOCIATION'
  },
  {
    payerId: 'VTX0172',
    payerName: 'AULTCARE'
  },
  {
    payerId: 'VTX0173',
    payerName: 'BRIDGESPAN'
  },
  {
    payerId: 'VTX0174',
    payerName: 'MUTUAL OF OMAHA'
  },
  {
    payerId: 'VTX0175',
    payerName: 'STANDARD LIFE AND ACCIDENT INSURANCE'
  },
  {
    payerId: 'VTX0176',
    payerName: 'TRICARE FOR LIFE'
  },
  {
    payerId: 'VTX0177',
    payerName: 'MEDICAID FLORIDA'
  },
  {
    payerId: 'VTX0178',
    payerName: 'AMERIHEALTH CARITAS PENNSYLVANIA'
  },
  {
    payerId: 'VTX0179',
    payerName: 'SPECTRUM HEALTH'
  },
  {
    payerId: 'VTX0180',
    payerName: 'HEALTHSPRINGS'
  },
  {
    payerId: 'VTX0181',
    payerName: 'AMERIHEALTH ADMINISTRATORS'
  },
  {
    payerId: 'VTX0182',
    payerName: 'HEALTH SERVICES FOR CHILDREN WITH SPECIAL NEEDS'
  },
  {
    payerId: 'VTX0183',
    payerName: 'EMBLEM HEALTH'
  },
  {
    payerId: 'VTX0184',
    payerName: 'MEDICAID GEORGIA'
  },
  {
    payerId: 'VTX0185',
    payerName: 'DAKOTACARE'
  },
  {
    payerId: 'VTX0186',
    payerName: 'GHI - GROUP HEALTH INC'
  },
  {
    payerId: 'VTX0187',
    payerName: 'AMERICAN NATIONAL LIFE INSURANCE COMPANY OF TEXAS'
  },
  {
    payerId: 'VTX0188',
    payerName: 'BEST LIFE AND HEALTH'
  },
  {
    payerId: 'VTX0189',
    payerName: 'LIFETIME BENEFIT SOLUTIONS'
  },
  {
    payerId: 'VTX0190',
    payerName: 'PRINCIPAL FINANCIAL GROUP'
  },
  {
    payerId: 'VTX0191',
    payerName: 'AMERICAN NATIONAL LIFE INSURANCE COMPANY OF TEXAS'
  },
  {
    payerId: 'VTX0192',
    payerName: 'MISSISSIPPI SEHP STATE EMPLOYEE HEALTH PLAN'
  },
  {
    payerId: 'VTX0193',
    payerName: 'PREMIER HEALTH'
  },
  {
    payerId: 'VTX0194',
    payerName: 'STANDARD INSURANCE COMPANY'
  },
  {
    payerId: 'VTX0195',
    payerName: 'ASR HEALTH BENEFITS'
  },
  {
    payerId: 'VTX0196',
    payerName: 'PERSONAL INSURANCE ADMINISTRATORS PIA'
  },
  {
    payerId: 'VTX0197',
    payerName: 'PHYSICIANS HEALTH PLAN NORTHERN INDIANA'
  },
  {
    payerId: 'VTX0198',
    payerName: 'MEDICAID OHIO'
  },
  {
    payerId: 'VTX0199',
    payerName: 'HIPNY'
  },
  {
    payerId: 'VTX0200',
    payerName: 'HEALTHPLAN SERVICES METLIFE INSURANCE CO'
  },
  {
    payerId: 'VTX0201',
    payerName: 'AARP'
  },
  {
    payerId: 'VTX0202',
    payerName: 'SUNSHINE HEALTH'
  },
  {
    payerId: 'VTX0203',
    payerName: 'CHCS SERVICES INC'
  },
  {
    payerId: 'VTX0204',
    payerName: 'PLANNED ADMINISTRATORS INC'
  },
  {
    payerId: 'VTX0205',
    payerName: 'PARTNERS NATIONAL HEALTH PLANS OF NC'
  },
  {
    payerId: 'VTX0206',
    payerName: 'CMFG LIFE INSURANCE'
  },
  {
    payerId: 'VTX0207',
    payerName: 'ARISE HEALTH PLAN'
  },
  {
    payerId: 'VTX0208',
    payerName: 'UCARE MINNESOTA'
  },
  {
    payerId: 'VTX0209',
    payerName: 'INTER VALLEY HEALTH PLAN CALIFORNIA'
  },
  {
    payerId: 'VTX0210',
    payerName: 'IBEW LOCAL 508 HEALTH PLAN'
  },
  {
    payerId: 'VTX0211',
    payerName: 'RECALL SYSTEMS - BOON-CHAPMAN BENEFIT ADMIN'
  },
  {
    payerId: 'VTX0212',
    payerName: 'INTEGRATED MENTAL HEALTH SERVICES'
  },
  {
    payerId: 'VTX0213',
    payerName: 'UNIVERSITY FAMILY CARE ARIZONA'
  },
  {
    payerId: 'VTX0214',
    payerName: 'MOLINA HEALTHCARE MICHIGAN'
  },
  {
    payerId: 'VTX0215',
    payerName: 'PROVIDENCE HEALTH PLAN'
  },
  {
    payerId: 'VTX0216',
    payerName: 'PACIFIC SOURCE HEALTH PLAN'
  },
  {
    payerId: 'VTX0217',
    payerName: 'CONNECTICARE'
  },
  {
    payerId: 'VTX0218',
    payerName: 'PERSONALCARE COVENTRY HEALTH OF ILLINOIS'
  },
  {
    payerId: 'VTX0219',
    payerName: 'CELTIC INSURANCE'
  },
  {
    payerId: 'VTX0220',
    payerName: 'UNITY HEALTH PLANS'
  },
  {
    payerId: 'VTX0221',
    payerName: 'MEDICAID MICHIGAN'
  },
  {
    payerId: 'VTX0222',
    payerName: 'UNIVERSAL CARE CALIFORNIA'
  },
  {
    payerId: 'VTX0223',
    payerName: 'MEDICAID INDIANA'
  },
  {
    payerId: 'VTX0224',
    payerName: 'MISSISSIPPI CHILDRENS HEALTH INSURANCE PROGRAM'
  },
  {
    payerId: 'VTX0225',
    payerName: 'NATIONAL MEDICARE CMS'
  },
  {
    payerId: 'VTX0226',
    payerName: 'INDEPENDENT HEALTH'
  },
  {
    payerId: 'VTX0227',
    payerName: 'HEALTHEZ'
  },
  {
    payerId: 'VTX0228',
    payerName: 'MAGNACARE'
  },
  {
    payerId: 'VTX0229',
    payerName: 'CAREPLUS HEALTH PLAN'
  },
  {
    payerId: 'VTX0230',
    payerName: 'SIERRA HEALTH SERVICES'
  },
  {
    payerId: 'VTX0231',
    payerName: 'CORESOURCE LITTLE ROCK'
  },
  {
    payerId: 'VTX0232',
    payerName: 'OXFORD HEALTH PLANS'
  },
  {
    payerId: 'VTX0233',
    payerName: 'COX HEALTH PLAN'
  },
  {
    payerId: 'VTX0234',
    payerName: 'QUAL CHOICE'
  },
  {
    payerId: 'VTX0235',
    payerName: 'PEHP UTAH'
  },
  {
    payerId: 'VTX0236',
    payerName: 'QUIKTRIP CORPORATION'
  },
  {
    payerId: 'VTX0237',
    payerName: 'AUXIANT'
  },
  {
    payerId: 'VTX0238',
    payerName: 'ALLSAVERS LIFE INSURANCE COMPANY'
  },
  {
    payerId: 'VTX0239',
    payerName: 'KEMPTON COMPANY'
  },
  {
    payerId: 'VTX0240',
    payerName: 'WEB TPA INC'
  },
  {
    payerId: 'VTX0241',
    payerName: 'OPERATING ENGINEERS LOCAL NO 428'
  },
  {
    payerId: 'VTX0242',
    payerName: 'SUMMACARE HEALTH PLAN'
  },
  {
    payerId: 'VTX0243',
    payerName: 'STUDENT INSURANCE'
  },
  {
    payerId: 'VTX0244',
    payerName: 'SELECT HEALTH UTAH'
  },
  {
    payerId: 'VTX0245',
    payerName: 'GROUP HEALTH COOPERATIVE'
  },
  {
    payerId: 'VTX0246',
    payerName: 'CENTRAL BENEFITS'
  },
  {
    payerId: 'VTX0247',
    payerName: 'PARTNERSHIP HEALTH PLAN OF CALIFORNIA'
  },
  {
    payerId: 'VTX0248',
    payerName: 'ROYAL NEIGHBORS OF AMERICA'
  },
  {
    payerId: 'VTX0249',
    payerName: 'ALTIUS HEALTH PLAN'
  },
  {
    payerId: 'VTX0250',
    payerName: 'GROUP AND PENSION ADMINISTRATORS'
  },
  {
    payerId: 'VTX0251',
    payerName: 'GOVERNMENT EMPLOYEES HEALTH ASSOCIATION (GEHA)'
  },
  {
    payerId: 'VTX0252',
    payerName: 'VETERANS AFFAIRS HEALTH ADMINISTRATION CENTER'
  },
  {
    payerId: 'VTX0253',
    payerName: 'THREE RIVERS HEALTH PLANS UNISON HEALTH PLAN'
  },
  {
    payerId: 'VTX0254',
    payerName: 'SAN JOAQUIN HEALTH PLAN'
  },
  {
    payerId: 'VTX0255',
    payerName: 'COUNTRY CUPBOARD'
  },
  {
    payerId: 'VTX0256',
    payerName: 'PHCS SAVILITY PAYERS'
  },
  {
    payerId: 'VTX0257',
    payerName: 'HEALTH NEW ENGLAND'
  },
  {
    payerId: 'VTX0258',
    payerName: 'KAISER FOUNDATION HEALTH PLAN OF HAWAII'
  },
  {
    payerId: 'VTX0259',
    payerName: 'PACIFICARE OF OKLAHOMA'
  },
  {
    payerId: 'VTX0260',
    payerName: 'COOK CHILDRENS HEALTH PLAN'
  },
  {
    payerId: 'VTX0261',
    payerName: 'CARE IMPROVEMENT PLUS'
  },
  {
    payerId: 'VTX0262',
    payerName: 'SELECTCARE OF TEXAS BEAUMONT'
  },
  {
    payerId: 'VTX0263',
    payerName: 'BOON GROUP'
  },
  {
    payerId: 'VTX0264',
    payerName: 'PASSPORT ADVANTAGE'
  },
  {
    payerId: 'VTX0265',
    payerName: 'SCHALLER ANDERSON AETNA BETTER HEALTH OF OHIO'
  },
  {
    payerId: 'VTX0266',
    payerName: 'HEALTH FIRST HEALTH PLAN'
  },
  {
    payerId: 'VTX0267',
    payerName: 'DEFINITY HEALTH'
  },
  {
    payerId: 'VTX0268',
    payerName: 'AMERITAS'
  },
  {
    payerId: 'VTX0270',
    payerName: 'CDS GROUP HEALTH'
  },
  {
    payerId: 'VTX0271',
    payerName: 'HERITAGE PHYSICIAN NETWORK (HOUSTON)'
  },
  {
    payerId: 'VTX0272',
    payerName: 'DAKOTA CARE'
  },
  {
    payerId: 'VTX0273',
    payerName: 'ANTHEM VIVITY'
  },
  {
    payerId: 'VTX0274',
    payerName: 'EPIC LIFE INSURANCE'
  },
  {
    payerId: 'VTX0275',
    payerName: 'NORTHWEST DIAGNOSTIC CLINIC'
  },
  {
    payerId: 'VTX0276',
    payerName: 'PACIFICARE OF CALIFORNIA'
  },
  {
    payerId: 'VTX0277',
    payerName: 'SELECTCARE OF TEXAS HOUSTON'
  },
  {
    payerId: 'VTX0278',
    payerName: 'PLAN HANDLERS'
  },
  {
    payerId: 'VTX0279',
    payerName: 'SIMPLY HEALTHCARE PLANS'
  },
  {
    payerId: 'VTX0280',
    payerName: 'AMERIBEN'
  },
  {
    payerId: 'VTX0281',
    payerName: 'NEHEN - NEIGHBORHOOD HEALTH PLANS'
  },
  {
    payerId: 'VTX0282',
    payerName: 'BUCKEYE COMMUNITY HEALTH PLAN'
  },
  {
    payerId: 'VTX0283',
    payerName: 'ORESOURCE (MD PA IL INCLUDES NC AND IN)'
  },
  {
    payerId: 'VTX0284',
    payerName: 'MEDSTAR HEALTH PLAN'
  },
  {
    payerId: 'VTX0285',
    payerName: 'HEALTH PLAN OF SAN MATEO'
  },
  {
    payerId: 'VTX0286',
    payerName: 'CARE MANAGEMENT COMPANY'
  },
  {
    payerId: 'VTX0287',
    payerName: 'EVERENCE FINANCIAL'
  },
  {
    payerId: 'VTX0288',
    payerName: 'KAISER FOUNDATION OF OH'
  },
  {
    payerId: 'VTX0289',
    payerName: 'LIFEWISE ARIZONA'
  },
  {
    payerId: 'VTX0291',
    payerName: 'ARIZONA PHYSICIANS IPA APIPA'
  },
  {
    payerId: 'VTX0292',
    payerName: 'HEALTH FIRST INSURANCE'
  },
  {
    payerId: 'VTX0293',
    payerName: 'FAMILYCARE'
  },
  {
    payerId: 'VTX0294',
    payerName: 'MOLINA HEALTHCARE FLORIDA'
  },
  {
    payerId: 'VTX0295',
    payerName: 'FEDERATED INSURANCE COMPANY'
  },
  {
    payerId: 'VTX0296',
    payerName: 'SELECTCARE OF TEXAS (INTEGRANET)'
  },
  {
    payerId: 'VTX0297',
    payerName: 'PRIMARY PHYSICIANCARE INC'
  },
  {
    payerId: 'VTX0298',
    payerName: 'KAISER FOUNDATION OF MID ATLANTIC'
  },
  {
    payerId: 'VTX0299',
    payerName: 'MVP HEALTH PLAN OF NY'
  },
  {
    payerId: 'VTX0300',
    payerName: 'KAISER PERMANENTE OF GEORGIA'
  },
  {
    payerId: 'VTX0301',
    payerName: 'COMMERCE BENEFITS GROUP'
  },
  {
    payerId: 'VTX0302',
    payerName: 'LOUISIANA HEALTH EXCHANGE'
  },
  {
    payerId: 'VTX0303',
    payerName: 'MEDICAID NEBRASKA'
  },
  {
    payerId: 'VTX0304',
    payerName: 'LIBERTY NATIONAL LIFE INSURANCE COMPANY'
  },
  {
    payerId: 'VTX0305',
    payerName: 'VYTRA'
  },
  {
    payerId: 'VTX0306',
    payerName: 'UMR'
  },
  {
    payerId: 'VTX0307',
    payerName: 'MEMORIAL CLINICAL ASSOCIATES'
  },
  {
    payerId: 'VTX0308',
    payerName: 'CARITEN HEALTHCARE'
  },
  {
    payerId: 'VTX0309',
    payerName: 'COORDINATED CARE'
  },
  {
    payerId: 'VTX0310',
    payerName: 'INLAND EMPIRE HEALTH PLAN CALIFORNIA'
  },
  {
    payerId: 'VTX0311',
    payerName: 'TMG HEALTH INSURANCE'
  },
  {
    payerId: 'VTX0312',
    payerName: 'STATE FARM'
  },
  {
    payerId: 'VTX0313',
    payerName: 'CALIFORNIA HEALTH AND WELLNESS'
  },
  {
    payerId: 'VTX0314',
    payerName: 'OMNICARE'
  },
  {
    payerId: 'VTX0315',
    payerName: 'HEALTH NET'
  },
  {
    payerId: 'VTX0316',
    payerName: 'MAMSI HEALTH PLAN'
  },
  {
    payerId: 'VTX0317',
    payerName: 'SELECTCARE OF TEXAS (HOUSTON)'
  },
  {
    payerId: 'VTX0318',
    payerName: 'PEACH STATE HEALTH PLAN'
  },
  {
    payerId: 'VTX0319',
    payerName: 'SELECT HEALTH OF SOUTH CAROLINA'
  },
  {
    payerId: 'VTX0320',
    payerName: 'REGENCE GROUP ADMINISTRATORS'
  },
  {
    payerId: 'VTX0321',
    payerName: 'MAIL HANDLERS BENEFIT PLAN'
  },
  {
    payerId: 'VTX0322',
    payerName: 'QUALCARE'
  },
  {
    payerId: 'VTX0323',
    payerName: 'SELECTCARE OF TEXAS (KELSEY-SEYBOLD)'
  },
  {
    payerId: 'VTX0324',
    payerName: 'SELECT SENIOR CLINIC'
  },
  {
    payerId: 'VTX0325',
    payerName: 'AMERICHOICE OF NEW JERSEY'
  },
  {
    payerId: 'VTX0326',
    payerName: 'SIGNIFICA BENEFIT SERVICES INC'
  },
  {
    payerId: 'VTX0327',
    payerName: 'CARESOURCE OF WEST VIRGINIA'
  },
  {
    payerId: 'VTX0328',
    payerName: 'STAYWELL'
  },
  {
    payerId: 'VTX0329',
    payerName: 'ASURIS NORTHWEST HEALTH'
  },
  {
    payerId: 'VTX0330',
    payerName: 'HARVARD PILGRIM HEALTHCARE'
  },
  {
    payerId: 'VTX0331',
    payerName: 'MEDICAID ALASKA'
  },
  {
    payerId: 'VTX0332',
    payerName: 'HEALTHE EXCHANGE'
  },
  {
    payerId: 'VTX0333',
    payerName: 'KAISER FOUNDATION HEALTH PLAN OF THE MID ATLANTIC'
  },
  {
    payerId: 'VTX0334',
    payerName: 'UNIVERSITY OF UTAH HEALTH PLANS'
  },
  {
    payerId: 'VTX0335',
    payerName: 'AMERICAN INCOME LIFE INSURANCE COMPANY'
  },
  {
    payerId: 'VTX0336',
    payerName: 'BANNER HEALTH'
  },
  {
    payerId: 'VTX0337',
    payerName: 'NATIONAL ASSOCIATION OF LETTER CARRIERS (NALC)'
  },
  {
    payerId: 'VTX0338',
    payerName: 'HUMANA'
  },
  {
    payerId: 'VTX0339',
    payerName: 'HEALTH PARTNERS'
  },
  {
    payerId: 'VTX0340',
    payerName: 'MEDICAID PUERTO RICO'
  },
  {
    payerId: 'VTX0341',
    payerName: 'HEALTHY TEXAS'
  },
  {
    payerId: 'VTX0342',
    payerName: 'SELECTCARE OF TEXAS KELSEY SEYBOLD'
  },
  {
    payerId: 'VTX0343',
    payerName: 'PHYSICIANS HEALTH PLAN MID-MICHIGAN'
  },
  {
    payerId: 'VTX0344',
    payerName: 'KEYSTONE MERCY HEALTH PLAN'
  },
  {
    payerId: 'VTX0345',
    payerName: 'CARESOURCE OF OHIO'
  },
  {
    payerId: 'VTX0346',
    payerName: 'MERITAIN HEALTH'
  },
  {
    payerId: 'VTX0347',
    payerName: 'PRIMEWEST HEALTH'
  },
  {
    payerId: 'VTX0348',
    payerName: 'ALAMEDA ALLIANCE HEALTH PLAN'
  },
  {
    payerId: 'VTX0349',
    payerName: 'PLAN DE SALUD HOSPITAL MENONITA'
  },
  {
    payerId: 'VTX0350',
    payerName: 'PACIFICARE OF TEXAS'
  },
  {
    payerId: 'VTX0351',
    payerName: 'WINDSOR HEALTH PLAN'
  },
  {
    payerId: 'VTX0352',
    payerName: 'LIFEWISE HEALTH PLAN OF WASHINGTON'
  },
  {
    payerId: 'VTX0353',
    payerName: 'TEXAS FIRST HEALTH PLANS TIOPA'
  },
  {
    payerId: 'VTX0354',
    payerName: 'SAN FRANCISCO HEALTH PLAN'
  },
  {
    payerId: 'VTX0355',
    payerName: 'MEDICO INSURANCE COMPANY'
  },
  {
    payerId: 'VTX0356',
    payerName: 'NEW ERA LIFE INSURANCE COMPANY'
  },
  {
    payerId: 'VTX0357',
    payerName: 'COUNTRY LIFE INSURANCE COMPANY'
  },
  {
    payerId: 'VTX0358',
    payerName: 'DESERET MUTUAL (DMBA)'
  },
  {
    payerId: 'VTX0359',
    payerName: 'GOLDEN RULE INSURANCE'
  },
  {
    payerId: 'VTX0360',
    payerName: 'UNIVERSAL CARE OF CALIFORNIA'
  },
  {
    payerId: 'VTX0361',
    payerName: 'ALTERNATIVE INSURANCE RESOURCES INC'
  },
  {
    payerId: 'VTX0362',
    payerName: 'PREFERRED CARE PARTNERS'
  },
  {
    payerId: 'VTX0363',
    payerName: 'HEALTHPLAN SERVICES TRUSTMARK LIFE'
  },
  {
    payerId: 'VTX0364',
    payerName: 'JOHNS HOPKINS HEALTHCARE'
  },
  {
    payerId: 'VTX0365',
    payerName: 'HEALTHFIRST OF NEW JERSEY'
  },
  {
    payerId: 'VTX0366',
    payerName: 'GEISINGER HEALTH PLAN-GOLD'
  },
  {
    payerId: 'VTX0367',
    payerName: 'KATY MEDICAL GROUP'
  },
  {
    payerId: 'VTX0368',
    payerName: 'WELLCARE HEALTH PLANS'
  },
  {
    payerId: 'VTX0369',
    payerName: 'COLORADO ACCESS'
  },
  {
    payerId: 'VTX0370',
    payerName: 'FRESENIUS HEALTH PARTNERS'
  },
  {
    payerId: 'VTX0371',
    payerName: 'CHAMPVA/SPINA BIFIDA/CHN OF WOMEN VIETNAM VETS'
  },
  {
    payerId: 'VTX0372',
    payerName: 'PLUMBERS AND PIPEFITTERS LOCAL UNION'
  },
  {
    payerId: 'VTX0373',
    payerName: 'SELECTCARE OF TEXAS (MEMORIAL CLINICAL ASSOC)'
  },
  {
    payerId: 'VTX0374',
    payerName: 'CARE1ST HEALTH PLAN ARIZONA'
  },
  {
    payerId: 'VTX0375',
    payerName: 'CONSOLIDATED ASSOCIATES RAILROAD'
  },
  {
    payerId: 'VTX0376',
    payerName: 'HEALTH SHARE OF OREGON'
  },
  {
    payerId: 'VTX0377',
    payerName: 'BANKERS LIFE AND CASUALTY'
  },
  {
    payerId: 'VTX0378',
    payerName: 'TEXAN PLUS KELSEY SEYBOLD'
  },
  {
    payerId: 'VTX0379',
    payerName: 'EVERCARE'
  },
  {
    payerId: 'VTX0380',
    payerName: 'BRIDGEWAY HEALTH SOLUTIONS'
  },
  {
    payerId: 'VTX0381',
    payerName: 'HEALTHPLAN SERVICES PHYSICIANS MUTUAL'
  },
  {
    payerId: 'VTX0382',
    payerName: 'ALLIED BENEFIT SYSTEMS INC'
  },
  {
    payerId: 'VTX0383',
    payerName: 'ISLAND HOME INSURANCE'
  },
  {
    payerId: 'VTX0384',
    payerName: 'HEALTHPLANS INC'
  },
  {
    payerId: 'VTX0385',
    payerName: 'MEDICAID CONNECTICUT'
  },
  {
    payerId: 'VTX0386',
    payerName: 'HORIZON NEW JERSEY HEALTH'
  },
  {
    payerId: 'VTX0387',
    payerName: 'HEALTHPLAN SERVICES CELTIC INSURANCE CO'
  },
  {
    payerId: 'VTX0388',
    payerName: 'MOLINA HEALTHCARE OF UTAH'
  },
  {
    payerId: 'VTX0389',
    payerName: 'FIDELIS CARE NEW YORK'
  },
  {
    payerId: 'VTX0390',
    payerName: 'AVMED'
  },
  {
    payerId: 'VTX0391',
    payerName: 'SUN ORTHOPAEDIC GROUP INC'
  },
  {
    payerId: 'VTX0392',
    payerName: 'AMERICAN POSTAL WORKERS UNION HEALTH PLAN APWU'
  },
  {
    payerId: 'VTX0393',
    payerName: 'TEXAS FIRST HEALTH PLANS'
  },
  {
    payerId: 'VTX0394',
    payerName: 'NATIONWIDE SPECIALTY HEALTH FKA NATIONWIDE HEALTH PLAN'
  },
  {
    payerId: 'VTX0395',
    payerName: 'SELECTCARE OF TEXAS (BEAUMONT)'
  },
  {
    payerId: 'VTX0396',
    payerName: 'NEIGHBORHOOD HEALTH PARTNERSHIP'
  },
  {
    payerId: 'VTX0397',
    payerName: 'WISCONSIN WELL WOMAN PROGRAM'
  },
  {
    payerId: 'VTX0398',
    payerName: 'TOUCHSTONE HEALTH HEALTHNET SMARTCHOICE'
  },
  {
    payerId: 'VTX0399',
    payerName: 'ABSOLUTE TOTAL CARE'
  },
  {
    payerId: 'VTX0400',
    payerName: 'BMC HEALTHNET'
  },
  {
    payerId: 'VTX0401',
    payerName: 'CULINARY HEALTH FUND UNITE HERE HEALTH'
  },
  {
    payerId: 'VTX0402',
    payerName: 'MERCY CARE PLAN (ARIZONA)'
  },
  {
    payerId: 'VTX0403',
    payerName: 'RELIANCE STANDARD LIFE INSURANCE COMPANY'
  },
  {
    payerId: 'VTX0404',
    payerName: 'INDEPENDENCE ADMINISTRATORS'
  },
  {
    payerId: 'VTX0405',
    payerName: 'COVENTRY MISSOURI'
  },
  {
    payerId: 'VTX0406',
    payerName: 'HMA - HEALTH MANAGMENT ADMIN'
  },
  {
    payerId: 'VTX0407',
    payerName: 'OPTIMA/SENTARA'
  },
  {
    payerId: 'VTX0408',
    payerName: 'KEY BENEFIT ADMINISTRATORS (INDIANAPOLIS IN)'
  },
  {
    payerId: 'VTX0409',
    payerName: 'DELAWARE PHYSICIANS CARE'
  },
  {
    payerId: 'VTX0410',
    payerName: 'MEGA LIFE AND HEALTH INSURANCE COMPANY HEALTHMARKETS'
  },
  {
    payerId: 'VTX0411',
    payerName: 'SHENANDOAH LIFE INSURANCE'
  },
  {
    payerId: 'VTX0412',
    payerName: 'MEDCOST BENEFIT SERVICES'
  },
  {
    payerId: 'VTX0413',
    payerName: 'HEALTHPLAN SERVICES FIRST HEALTH LIFE'
  },
  {
    payerId: 'VTX0414',
    payerName: 'MHNET BEHAVIORAL HEALTH'
  },
  {
    payerId: 'VTX0415',
    payerName: 'MOUNTAIN STATE'
  },
  {
    payerId: 'VTX0416',
    payerName: 'PURITAN LIFE INSURANCE'
  },
  {
    payerId: 'VTX0417',
    payerName: 'SELECTCARE OF TEXAS (NORTHWEST DIAGNOSTIC)'
  },
  {
    payerId: 'VTX0418',
    payerName: 'SCHALLER ANDERSON MARYLAND PHYSICIANS CARE'
  },
  {
    payerId: 'VTX0419',
    payerName: 'BOSTON MEDICAL CENTER HEALTHNET PLAN'
  },
  {
    payerId: 'VTX0420',
    payerName: 'MARICOPA HEALTH PLAN ARIZONA'
  },
  {
    payerId: 'VTX0421',
    payerName: 'MERIDIAN HEALTH PLAN OF ILLINOIS'
  },
  {
    payerId: 'VTX0422',
    payerName: 'MEDICAL ASSOCIATES HEALTH PLAN - HEALTH CHOICES'
  },
  {
    payerId: 'VTX0423',
    payerName: 'VALLEY CARE PROGRAM'
  },
  {
    payerId: 'VTX0424',
    payerName: 'UNION PACIFIC RAILROAD EMPLOYES HEALTH SYSTEM'
  },
  {
    payerId: 'VTX0425',
    payerName: 'HEALTHNOW'
  },
  {
    payerId: 'VTX0426',
    payerName: 'FALLON COMMUNITY HEALTH PLAN'
  },
  {
    payerId: 'VTX0427',
    payerName: 'EMPLOYEE BENEFIT MANAGEMENT SYSTEM (EBMS)'
  },
  {
    payerId: 'VTX0428',
    payerName: 'MANAGED CARE OF AMERICA'
  },
  {
    payerId: 'VTX0429',
    payerName: 'HIGHMARK HEALTH INSURANCE COMPANY'
  },
  {
    payerId: 'VTX0430',
    payerName: 'PREFERRED ONE'
  },
  {
    payerId: 'VTX0431',
    payerName: 'MI CHILD'
  },
  {
    payerId: 'VTX0432',
    payerName: 'LOOMIS COMPANY'
  },
  {
    payerId: 'VTX0433',
    payerName: 'ARBOR HEALTH PLAN'
  },
  {
    payerId: 'VTX0434',
    payerName: 'ILLINICARE HEALTH PLAN'
  },
  {
    payerId: 'VTX0435',
    payerName: 'NEIGHBORHOOD HEALTH PLAN (RI)'
  },
  {
    payerId: 'VTX0436',
    payerName: 'HARMONY HEALTH PLAN'
  },
  {
    payerId: 'VTX0437',
    payerName: 'EVERGREEN HEALTH CO-OP'
  },
  {
    payerId: 'VTX0438',
    payerName: 'STAR HRG'
  },
  {
    payerId: 'VTX0439',
    payerName: 'CLAIMS MANAGEMENT SERVICE INC'
  },
  {
    payerId: 'VTX0440',
    payerName: 'EVANGELICAL COMMUNITY HOSPITAL'
  },
  {
    payerId: 'VTX0441',
    payerName: 'MANAGED HEALTH SERVICES IN'
  },
  {
    payerId: 'VTX0442',
    payerName: 'KITSAP PHYSICIAN SERVICES'
  },
  {
    payerId: 'VTX0443',
    payerName: 'UPMC HEALTH PLAN (TRISTATE)'
  },
  {
    payerId: 'VTX0444',
    payerName: 'NOVASYS HEALTH'
  },
  {
    payerId: 'VTX0445',
    payerName: 'AFTRA HEALTH FUND'
  },
  {
    payerId: 'VTX0446',
    payerName: 'MEDICAID IDAHO'
  },
  {
    payerId: 'VTX0447',
    payerName: 'MEGA LIFE OKLAHOMA CITY'
  },
  {
    payerId: 'VTX0448',
    payerName: 'TRICARE OVERSEAS'
  },
  {
    payerId: 'VTX0449',
    payerName: 'MEDICAID NORTH CAROLINA'
  },
  {
    payerId: 'VTX0450',
    payerName: 'BETTER HEALTH PLANS UNISON HEALTH PLAN'
  },
  {
    payerId: 'VTX0451',
    payerName: 'DENVER HEALTH MEDICAL PLAN'
  },
  {
    payerId: 'VTX0452',
    payerName: 'AMERIHEALTH CARITAS LOUISIANA'
  },
  {
    payerId: 'VTX0453',
    payerName: 'BLUE CROSS BLUE SHIELD'
  },
  {
    payerId: 'VTX0454',
    payerName: 'KEYSTONE HEALTH PLAN EAST'
  },
  {
    payerId: 'VTX0455',
    payerName: 'STAYWELL KIDS'
  },
  {
    payerId: 'VTX0456',
    payerName: 'VETERANS AFFAIRS FEE BASIS PROGRAM'
  },
  {
    payerId: 'VTX0457',
    payerName: 'TOUCHSTONE PSO'
  },
  {
    payerId: 'VTX0458',
    payerName: 'OKLAHOMA EMPLOYEES GROUP INSURANCE'
  },
  {
    payerId: 'VTX0459',
    payerName: 'CORESOURCE (FMH)'
  },
  {
    payerId: 'VTX0460',
    payerName: 'VANTAGE HEALTH PLAN INC'
  },
  {
    payerId: 'VTX0461',
    payerName: 'SANTA CLARA FAMILY HEALTH PLAN'
  },
  {
    payerId: 'VTX0462',
    payerName: 'MOLINA HEALTHCARE OF MISSOURI'
  },
  {
    payerId: 'VTX0463',
    payerName: 'SELECT SENIOR CLINIC'
  },
  {
    payerId: 'VTX0464',
    payerName: 'MOLINA HEALTHCARE OF TEXAS'
  },
  {
    payerId: 'VTX0465',
    payerName: 'HEALTHEASE'
  },
  {
    payerId: 'VTX0466',
    payerName: 'SUTTER SELECT'
  },
  {
    payerId: 'VTX0467',
    payerName: 'INTER VALLEY HEALTH PLAN'
  },
  {
    payerId: 'VTX0468',
    payerName: 'MANAGED HEALTH SERVICES WI'
  },
  {
    payerId: 'VTX0469',
    payerName: 'HEALTHSCOPE BENEFITS'
  },
  {
    payerId: 'VTX0470',
    payerName: 'SCHALLER ANDERSON PARKLAND COMMUNITY'
  },
  {
    payerId: 'VTX0471',
    payerName: 'HEALTHCARE SOLUTIONS GROUP'
  },
  {
    payerId: 'VTX0472',
    payerName: 'CENTERLIGHT HEALTHCARE INC'
  },
  {
    payerId: 'VTX0473',
    payerName: 'MED-PAY INC'
  },
  {
    payerId: 'VTX0474',
    payerName: 'STANDARD LIFE INSURANCE COMPANY OF NEW YORK'
  },
  {
    payerId: 'VTX0475',
    payerName: 'PASSPORT HEALTH PLAN'
  },
  {
    payerId: 'VTX0476',
    payerName: 'MEDICAID TENNESSEE'
  },
  {
    payerId: 'VTX0477',
    payerName: 'TRUSTMARK'
  },
  {
    payerId: 'VTX0478',
    payerName: 'SCHALLER ANDERSON MERCY CARE PLAN'
  },
  {
    payerId: 'VTX0479',
    payerName: 'VILLAGE FAMILY PRACTICE'
  },
  {
    payerId: 'VTX0480',
    payerName: 'EBMS'
  },
  {
    payerId: 'VTX0481',
    payerName: 'TRANSAMERICA LIFE INSURANCE HEALTHMARKETS'
  },
  {
    payerId: 'VTX0482',
    payerName: 'GEISINGER HEALTH PLAN'
  },
  {
    payerId: 'VTX0483',
    payerName: 'LINCOLN HERITAGE'
  },
  {
    payerId: 'VTX0484',
    payerName: 'MOLINA HEALTHCARE OF SOUTH CAROLINA'
  },
  {
    payerId: 'VTX0485',
    payerName: 'CELTICARE HEALTH PLAN'
  },
  {
    payerId: 'VTX0486',
    payerName: 'VIVA HEALTH INC.'
  },
  {
    payerId: 'VTX0487',
    payerName: 'HOMETOWN HEALTH'
  },
  {
    payerId: 'VTX0488',
    payerName: 'NIPPON LIFE BENEFITS'
  },
  {
    payerId: 'VTX0489',
    payerName: 'COMMUNITY CARE OF OKLAHOMA'
  },
  {
    payerId: 'VTX0490',
    payerName: 'AETNA'
  },
  {
    payerId: 'VTX0491',
    payerName: 'SCHALLER ANDERSON INTEGRAL QUALITY CARE FL'
  },
  {
    payerId: 'VTX0492',
    payerName: 'FIRST AMERITAS OF NEW YORK'
  },
  {
    payerId: 'VTX0494',
    payerName: 'CAPROCK'
  },
  {
    payerId: 'VTX0495',
    payerName: 'PUBLIC EMPLOYEES HEALTH PLAN (PEHP)'
  },
  {
    payerId: 'VTX0496',
    payerName: 'MORRIS ASSOCIATES'
  },
  {
    payerId: 'VTX0497',
    payerName: 'IBM INSURANCE OUTSOURCING SERVICES'
  },
  {
    payerId: 'VTX0498',
    payerName: 'BC OF IDAHO'
  },
  {
    payerId: 'VTX0499',
    payerName: 'HEALTH PLAN OF UPPER OHIO VALLEY'
  },
  {
    payerId: 'VTX0500',
    payerName: 'HUMANA CARESOURCE'
  },
  {
    payerId: 'VTX0501',
    payerName: 'UNICARE'
  },
  {
    payerId: 'VTX0502',
    payerName: 'CHRISTIAN BROTHERS SERVICES'
  },
  {
    payerId: 'VTX0503',
    payerName: 'WASHINGTON NATIONAL'
  },
  {
    payerId: 'VTX0504',
    payerName: 'CAPITAL DISTRICT PHYSICIANS HEALTH PLAN (CDPHP)'
  },
  {
    payerId: 'VTX0505',
    payerName: 'FLORIDA HOSPITAL HEALTHCARE SYSTEM'
  },
  {
    payerId: 'VTX0506',
    payerName: 'CENCAL'
  },
  {
    payerId: 'VTX0507',
    payerName: 'FLORIDA HEALTH CARE PLANS'
  },
  {
    payerId: 'VTX0508',
    payerName: 'MOLINA HEALTHCARE OHIO'
  },
  {
    payerId: 'VTX0509',
    payerName: 'BEST CHOICE HEALTH PLAN'
  },
  {
    payerId: 'VTX0510',
    payerName: 'WRITERS GUILD'
  },
  {
    payerId: 'VTX0511',
    payerName: 'CHESAPEAKE NATIONAL LIFE INSURANCE HEALTHMARKETS'
  },
  {
    payerId: 'VTX0512',
    payerName: 'UNION SECURITY INSURANCE COMPANY ASSURANT HEALTH'
  },
  {
    payerId: 'VTX0513',
    payerName: 'DEAN HEALTH PLAN'
  },
  {
    payerId: 'VTX0514',
    payerName: 'MEDICAID KENTUCKY'
  },
  {
    payerId: 'VTX0515',
    payerName: 'MEDICA'
  },
  {
    payerId: 'VTX0516',
    payerName: 'MEDICA INSURANCE'
  },
  {
    payerId: 'VTX0517',
    payerName: 'Inland Empire Health Plan'
  },
  {
    payerId: 'VTX0518',
    payerName: '1199 National Benefit Fund (SEUI)'
  },
  {
    payerId: 'VTX0519',
    payerName: 'KAISER PERMANENTE SOUTHERN CALIFORNIA'
  },
  {
    payerId: 'VTX0520',
    payerName: 'KAISER PERMANENTE NORTHERN CALIFORNIA'
  },
  {
    payerId: 'VTX0521',
    payerName: 'AMBETTER'
  },
  {
    payerId: 'VTX0522',
    payerName: 'MEDICAID NEW JERSEY'
  },
  {
    payerId: 'VTX0523',
    payerName: 'MAGELLAN HEALTH SERVICES'
  },
  {
    payerId: 'VTX0524',
    payerName: 'TRICARE EAST'
  },
  {
    payerId: 'VTX0525',
    payerName: 'MODA HEALTH'
  },
  {
    payerId: 'VTX0526',
    payerName: 'UNITED BEHAVIORAL HEALTH'
  },
  {
    payerId: 'VTX0527',
    payerName: 'AMERIHEALTH DELAWARE'
  },
  {
    payerId: 'VTX0528',
    payerName: 'AMERIHEALTH DISTRICT OF COLUMBIA'
  },
  {
    payerId: 'VTX0529',
    payerName: 'AMERIHEALTH CARITAS IOWA'
  },
  {
    payerId: 'VTX0530',
    payerName: 'INDEPENDENCE BLUE CROSS'
  },
  {
    payerId: 'VTX0531',
    payerName: 'BLUE CROSS AND BLUE SHIELD OF ILLINOIS'
  },
  {
    payerId: 'VTX0532',
    payerName: 'BLUE CROSS AND BLUE SHIELD OF TEXAS'
  },
  {
    payerId: 'VTX0533',
    payerName: 'BLUE CROSS AND BLUE SHIELD OF ALABAMA'
  },
  {
    payerId: 'VTX0534',
    payerName: 'ANTHEM BLUE CROSS'
  },
  {
    payerId: 'VTX0535',
    payerName: 'BLUE CROSS BLUE SHIELD OF ARIZONA'
  },
  {
    payerId: 'VTX0536',
    payerName: 'Premera Blue Cross and Blue Shield of Alaska'
  },
  {
    payerId: 'VTX0537',
    payerName: 'Arkansas Blue Cross and Blue Shield'
  },
  {
    payerId: 'VTX0538',
    payerName: 'Anthem Blue Cross and Blue Shield Colorado'
  },
  {
    payerId: 'VTX0539',
    payerName: 'Anthem Blue Cross and Blue Shield Connecticut'
  },
  {
    payerId: 'VTX0540',
    payerName: 'Highmark Blue Cross Blue Shield Delaware'
  },
  {
    payerId: 'VTX0541',
    payerName: 'CareFirst BlueCross BlueShield'
  },
  {
    payerId: 'VTX0542',
    payerName: 'FLORIDA BLUE'
  },
  {
    payerId: 'VTX0543',
    payerName: 'Blue Cross Blue Shield of Georgia'
  },
  {
    payerId: 'VTX0544',
    payerName: 'Blue Cross and Blue Shield of Hawaii'
  },
  {
    payerId: 'VTX0545',
    payerName: 'Blue Cross of Idaho'
  },
  {
    payerId: 'VTX0546',
    payerName: 'Anthem Blue Cross and Blue Shield Indiana'
  },
  {
    payerId: 'VTX0547',
    payerName: 'Wellmark Blue Cross and Blue Shield'
  },
  {
    payerId: 'VTX0548',
    payerName: 'Blue Cross and Blue Shield of Kansas'
  },
  {
    payerId: 'VTX0549',
    payerName: 'Anthem Blue Cross and Blue Shield Kentucky'
  },
  {
    payerId: 'VTX0550',
    payerName: 'Anthem Blue Cross and Blue Shield Maine'
  },
  {
    payerId: 'VTX0551',
    payerName: 'CareFirst BlueCross BlueShield'
  },
  {
    payerId: 'VTX0552',
    payerName: 'Blue Cross and Blue Shield of Massachusetts'
  },
  {
    payerId: 'VTX0553',
    payerName: 'Blue Cross Blue Shield of Michigan'
  },
  {
    payerId: 'VTX0554',
    payerName: 'Blue Cross and Blue Shield of Minnesota'
  },
  {
    payerId: 'VTX0555',
    payerName: 'Blue Cross & Blue Shield of Mississippi'
  },
  {
    payerId: 'VTX0556',
    payerName: 'Anthem Blue Cross and Blue Shield Missouri'
  },
  {
    payerId: 'VTX0557',
    payerName: 'Blue Cross and Blue Shield of Kansas City'
  },
  {
    payerId: 'VTX0558',
    payerName: 'Blue Cross and Blue Shield of Montana'
  },
  {
    payerId: 'VTX0559',
    payerName: 'Blue Cross and Blue Shield of Nebraska'
  },
  {
    payerId: 'VTX0560',
    payerName: 'Anthem Blue Cross and Blue Shield Nevada'
  },
  {
    payerId: 'VTX0561',
    payerName: 'Anthem Blue Cross and Blue Shield New Hampshire'
  },
  {
    payerId: 'VTX0562',
    payerName: 'Horizon Blue Cross and Blue Shield of New Jersey'
  },
  {
    payerId: 'VTX0563',
    payerName: 'Blue Cross and Blue Shield of New Mexico'
  },
  {
    payerId: 'VTX0564',
    payerName: 'Empire Blue Cross Blue Shield'
  },
  {
    payerId: 'VTX0565',
    payerName: 'BlueCross BlueShield of Western New York'
  },
  {
    payerId: 'VTX0566',
    payerName: 'BlueShield of Northeastern New York'
  },
  {
    payerId: 'VTX0567',
    payerName: 'Excellus BlueCross BlueShield'
  },
  {
    payerId: 'VTX0568',
    payerName: 'Blue Cross and Blue Shield of North Carolina'
  },
  {
    payerId: 'VTX0569',
    payerName: 'Blue Cross Blue Shield of North Dakota'
  },
  {
    payerId: 'VTX0570',
    payerName: 'Anthem Blue Cross and Blue Shield Ohio'
  },
  {
    payerId: 'VTX0571',
    payerName: 'Blue Cross and Blue Shield of Oklahoma'
  },
  {
    payerId: 'VTX0572',
    payerName: 'Regence BlueCross BlueShield'
  },
  {
    payerId: 'VTX0573',
    payerName: 'Capital Blue Cross'
  },
  {
    payerId: 'VTX0574',
    payerName: 'MEDICAID NEVADA'
  },
  {
    payerId: 'VTX0575',
    payerName: 'BlueCross BlueShield of Puerto Rico'
  },
  {
    payerId: 'VTX0576',
    payerName: 'Blue Cross & Blue Shield of Rhode Island'
  },
  {
    payerId: 'VTX0577',
    payerName: 'Wellmark Blue Cross and Blue Shield'
  },
  {
    payerId: 'VTX0578',
    payerName: 'BlueCross BlueShield of Tennessee'
  },
  {
    payerId: 'VTX0579',
    payerName: 'Blue Cross and Blue Shield of Vermont'
  },
  {
    payerId: 'VTX0580',
    payerName: 'Anthem Blue Cross and Blue Shield Virginia'
  },
  {
    payerId: 'VTX0581',
    payerName: 'CareFirst BlueCross BlueShield'
  },
  {
    payerId: 'VTX0582',
    payerName: 'Premera Blue Cross'
  },
  {
    payerId: 'VTX0583',
    payerName: 'Regence BlueShield'
  },
  {
    payerId: 'VTX0584',
    payerName: 'Highmark Blue Cross Blue Shield West Virginia'
  },
  {
    payerId: 'VTX0585',
    payerName: 'Anthem Blue Cross and Blue Shield Wisconsin'
  },
  {
    payerId: 'VTX0586',
    payerName: 'Blue Cross Blue Shield of Wyoming'
  },
  {
    payerId: 'VTX0587',
    payerName: 'MEDICAID BCBSMN BLUE PLUS'
  },
  {
    payerId: 'VTX0588',
    payerName: 'MEDICAID MVP MANAGED CARE'
  },
  {
    payerId: 'VTX0589',
    payerName: 'MEDICAID SCHALLER ANDERSON AETNA ILLINOIS'
  },
  {
    payerId: 'VTX0590',
    payerName: 'MEDICAID SCHALLER ANDERSON AETNA TEXAS AND CHIP'
  },
  {
    payerId: 'VTX0591',
    payerName: "MEDICAID TEXAS CHILDREN'S HEALTH PLAN CHIP"
  },
  {
    payerId: 'VTX0592',
    payerName: 'MEDICAID VISTA FLORIDA HEALTH KIDS LONG TERM CARE PRODUCTS ONLY'
  },
  {
    payerId: 'VTX0593',
    payerName: 'MEDICAID BCBSMN BLUE PLUS NON-EMERG TRANSPORTATION'
  },
  {
    payerId: 'VTX0594',
    payerName: 'MEDICAID BCBS OF WESTERN NEW YORK '
  },
  {
    payerId: 'VTX0595',
    payerName: 'MEDICAID BCBS OF WESTERN NEW YORK '
  },
  {
    payerId: 'VTX0596',
    payerName: 'MEDICAID COVENTRY HEALTH CARE CARELINK '
  },
  {
    payerId: 'VTX0597',
    payerName: 'MEDICAID DIAMOND PLAN MARYLAND'
  },
  {
    payerId: 'VTX0598',
    payerName: 'Anthem Blue Cross California'
  },
  {
    payerId: 'VTX0599',
    payerName: 'MEDICAID TEXAS'
  },
  {
    payerId: 'VTX0600',
    payerName: 'BRIGHT HEALTH PLAN'
  },
  {
    payerId: 'VTX0601',
    payerName: 'KAISER FOUNDATION HEALTH PLAN WASHINGTON'
  },
  {
    payerId: 'VTX0602',
    payerName: 'ALLWAYS HEALTH PARTNERS'
  },
  {
    payerId: 'VTX0603',
    payerName: 'COMMUNITY HEALTH GROUP'
  },
  {
    payerId: 'VTX0604',
    payerName: 'COMPSYCH'
  },
  {
    payerId: 'VTX0605',
    payerName: 'SIERRA HEALTH SERVICES'
  },
  {
    payerId: 'VTX0606',
    payerName: 'HEALTH PLAN OF NEVADA'
  },
  {
    payerId: 'VTX0607',
    payerName: 'UNITEDHEALTHCARE COMMUNITY PLAN ARIZONA'
  },
  {
    payerId: 'VTX0608',
    payerName: 'ARIZONA COMPLETE HEALTH'
  },
  {
    payerId: 'VTX0609',
    payerName: 'PARAMOUNT HEALTHCARE'
  },
  {
    payerId: 'VTX0610',
    payerName: 'MANAGED HEALTH NETWORKS (MHN)'
  },
  {
    payerId: 'VTX0611',
    payerName: 'HEALTHFIRST NEW YORK'
  },
  {
    payerId: 'VTX0612',
    payerName: 'HEALTHFIRST INCORPORATED NEW YORK'
  },
  {
    payerId: 'VTX0613',
    payerName: 'AMERIHEALTH NEW JERSEY AND DELAWARE HMO ONLY'
  },
  {
    payerId: 'VTX0614',
    payerName: 'MEDICAID MASSACHUSETTS'
  },
  {
    payerId: 'VTX0615',
    payerName: 'MEDICAID ARKANSAS'
  },
  {
    payerId: 'VTX0616',
    payerName: 'MEDICAID ALABAMA'
  },
  {
    payerId: 'VTX0617',
    payerName: 'MEDICAID WYOMING'
  },
  {
    payerId: 'VTX0618',
    payerName: 'MEDICAID WISCONSIN'
  },
  {
    payerId: 'VTX0619',
    payerName: 'MEDICAID WEST VIRGINIA'
  },
  {
    payerId: 'VTX0620',
    payerName: 'MEDICAID VERMONT'
  },
  {
    payerId: 'VTX0621',
    payerName: 'MEDICAID UTAH'
  },
  {
    payerId: 'VTX0622',
    payerName: 'MEDICAID TEXAS AND TEXAS HEALTH STEPS'
  },
  {
    payerId: 'VTX0623',
    payerName: 'MEDICAID SOUTH CAROLINA'
  },
  {
    payerId: 'VTX0624',
    payerName: 'MEDICAID OREGON'
  },
  {
    payerId: 'VTX0625',
    payerName: 'MEDICAID OKLAHOMA'
  },
  {
    payerId: 'VTX0626',
    payerName: 'MEDICAID NORTH DAKOTA'
  },
  {
    payerId: 'VTX0627',
    payerName: 'MEDICAID NEW YORK'
  },
  {
    payerId: 'VTX0628',
    payerName: 'MEDICAID NEW HAMPSHIRE'
  },
  {
    payerId: 'VTX0629',
    payerName: 'MEDICAID NEBRASKA'
  },
  {
    payerId: 'VTX0630',
    payerName: 'MEDICAID MONTANA'
  },
  {
    payerId: 'VTX0631',
    payerName: 'MEDICAID MISSOURI'
  },
  {
    payerId: 'VTX0632',
    payerName: 'MEDICAID MISSISSIPPI'
  },
  {
    payerId: 'VTX0633',
    payerName: 'MEDICAID MICHIGAN PENDING ELIGIBILITY'
  },
  {
    payerId: 'VTX0634',
    payerName: 'MEDICAID MARYLAND'
  },
  {
    payerId: 'VTX0635',
    payerName: 'MEDICAID MAINE'
  },
  {
    payerId: 'VTX0636',
    payerName: 'MEDICAID LOUISIANA'
  },
  {
    payerId: 'VTX0637',
    payerName: 'MEDICAID IOWA'
  },
  {
    payerId: 'VTX0638',
    payerName: 'MEDICAID DISTRICT OF COLUMBIA'
  },
  {
    payerId: 'VTX0639',
    payerName: 'MEDICAID DELAWARE'
  },
  {
    payerId: 'VTX0640',
    payerName: 'MEDICAID COLORADO'
  },
  {
    payerId: 'VTX0641',
    payerName: 'MEDICAID CALIFORNIA MEDI-CAL'
  },
  {
    payerId: 'VTX0642',
    payerName: 'Highmark Blue Shield'
  },
  {
    payerId: 'VTX0643',
    payerName: 'UNITEDHEALTHCARE OXFORD'
  },
  {
    payerId: 'VTX0644',
    payerName: 'TRICARE WEST'
  },
  {
    payerId: 'VTX0645',
    payerName: 'MEDICAID VIRGINIA'
  },
  {
    payerId: 'VTX0646',
    payerName: 'OSCAR HEALTH'
  },
  {
    payerId: 'VTX0647',
    payerName: 'TRICARE WEST REGION'
  },
  {
    payerId: 'VTX0648',
    payerName: 'AETNA BETTER HEALTH'
  },
  {
    payerId: 'VTX0649',
    payerName: 'SCOTT AND WHITE HEALTH CARE PLAN'
  },
  {
    payerId: 'VTX0650',
    payerName: 'EMI Health'
  },
  {
    payerId: 'VTX0651',
    payerName: 'COLORADO COMMUNITY HEALTH ALLIANCE'
  },
  {
    payerId: 'VTX0652',
    payerName: 'COMMUNITY HEALTH PLAN OF WASHINGTON'
  },
  {
    payerId: 'VTX0653',
    payerName: 'Southeastern Indiana Health (SIHO)'
  },
  {
    payerId: 'VTX0654',
    payerName: 'UMWA Health & Retirement'
  },
  {
    payerId: 'VTX0655',
    payerName: 'MCLAREN HEALTH PLAN'
  },
  {
    payerId: 'VTX0656',
    payerName: 'HEALTHGRAM INCORPORATED'
  },
  {
    payerId: 'VTX0657',
    payerName: 'SELF PAY'
  },
  {
    payerId: 'VTX0658',
    payerName: 'SCHOLARSHIP'
  },
  {
    payerId: 'VTX0659',
    payerName: 'SUPERIOR HEALTH PLAN'
  },
  {
    payerId: 'VTX0660',
    payerName: 'SCOTT AND WHITE HEALTH CARE PLAN'
  },
  {
    payerId: 'VTX0661',
    payerName: 'SCOTT AND WHITE HEALTH PLAN'
  },
  {
    payerId: 'VTX0662',
    payerName: 'HEALTH PLANS INCORPORATED'
  },
  {
    payerId: 'VTX0663',
    payerName: 'MEDICAID ARIZONA'
  },
  {
    payerId: 'VTX0664',
    payerName: 'MEDICAID WASHINGTON (PROVIDER ONE)'
  },
  {
    payerId: 'VTX0665',
    payerName: 'OPTUM UNITED HEALTH BEHAVIORAL SOLUTIONS'
  },
  {
    payerId: 'VTX0666',
    payerName: 'CareSource Arkansas'
  },
  {
    payerId: 'VTX0667',
    payerName: 'MARTINS POINT HEALTH CARE'
  },
  {
    payerId: 'VTX0668',
    payerName: 'MEDICARE FLORIDA BLUE'
  },
  {
    payerId: 'VTX0669',
    payerName: 'CENTENE MEDICARE'
  },
  {
    payerId: 'VTX0670',
    payerName: 'FREEDOM BLUE MEDICARE ADANTAGE INSTITUTIONAL'
  },
  {
    payerId: 'VTX0671',
    payerName: 'BLUE MEDICARE ADVANTAGE'
  },
  {
    payerId: 'VTX0672',
    payerName: 'GILSBAR'
  },
  {
    payerId: 'VTX0673',
    payerName: 'GROUP AND PENSION ADMINISTRATORS'
  },
  {
    payerId: 'VTX0674',
    payerName: 'HEALTHCOMP (COMMUNITY FIRST STAR HEALTH PLAN)'
  },
  {
    payerId: 'VTX0675',
    payerName: 'INDIANA UNIVERISTY HEALTH PLAN COMMERCIAL'
  },
  {
    payerId: 'VTX0676',
    payerName: 'HEALTHSCOPE BENEFITS INCORPORATED'
  },
  {
    payerId: 'VTX0677',
    payerName: 'HEALTHSCOPE BENEFITS INCORPORATED (MORRIS ASSOCIATES)'
  },
  {
    payerId: 'VTX0678',
    payerName: 'HEALTHSCOPE HSB'
  },
  {
    payerId: 'VTX0679',
    payerName: 'HOMETOWN HEALTH NETWORK'
  },
  {
    payerId: 'VTX0680',
    payerName: 'INDIANA UNIVERSITY HEALTH PLAN'
  },
  {
    payerId: 'VTX0681',
    payerName: 'SISCO'
  },
  {
    payerId: 'VTX0682',
    payerName: 'TRILLIUM COMMUNITY HEALTH PLAN'
  },
  {
    payerId: 'VTX0683',
    payerName: 'CAROLINA COMPLETE HEALTH'
  },
  {
    payerId: 'VTX0684',
    payerName: 'SECURITY HEALTH PLAN'
  },
  {
    payerId: 'VTX0685',
    payerName: 'BEACON HEALTH OPTIONS'
  },
  {
    payerId: 'VTX0686',
    payerName: 'AVERA HEALTH PLAN'
  },
  {
    payerId: 'VTX0687',
    payerName: 'BIND'
  },
  {
    payerId: 'VTX0688',
    payerName: 'HAWAII MAINLAND ADMINISTRATORS'
  },
  {
    payerId: 'VTX0689',
    payerName: 'VETERANS AFFAIRS COMMUNITY CARE NETWORK'
  },
  {
    payerId: 'VTX0690',
    payerName: 'CHRISTUS HEALTH'
  },
  {
    payerId: 'VTX0691',
    payerName: 'HEALTHCARE HIGHWAYS'
  },
  {
    payerId: 'VTX0692',
    payerName: 'THE HEALTH PLAN WEST VIRGINIA'
  },
  {
    payerId: 'VTX0693',
    payerName: 'MEDICAID WASHINGTON'
  },
  {
    payerId: 'VTX0694',
    payerName: 'SHARP HEALTH PLAN'
  },
  {
    payerId: 'VTX0695',
    payerName: 'LOVELACE HEALTH PLAN'
  },
  {
    payerId: 'VTX0695',
    payerName: 'CORESOURCE DETROIT'
  },
  {
    payerId: 'VTX0696',
    payerName: 'FIRST CHOICE HEALTH NETWORK'
  },
  {
    payerId: 'VTX0697',
    payerName: 'SANA BENEFITS'
  },
  {
    payerId: 'VTX0698',
    payerName: 'ACS BENEFIT SERVICES'
  },
  {
    payerId: 'VTX0699',
    payerName: 'AFFINITY ESSENTIALS'
  },
  {
    payerId: 'VTX0700',
    payerName: 'ALBUQUERQUE PUBLIC SCHOOLS'
  },
  {
    payerId: 'VTX0701',
    payerName: 'AFLAC MEDICARE SUPPLEMENTAL'
  },
  {
    payerId: 'VTX0703',
    payerName: 'ALOHA CARE'
  },
  {
    payerId: 'VTX0704',
    payerName: 'AMERICAN FAMILY INSURANCE GROUP'
  },
  {
    payerId: 'VTX0705',
    payerName: 'AMERICAN INSURANCE ADMINISTRATORS (AIA)'
  },
  {
    payerId: 'VTX0706',
    payerName: 'AMERICAN NETWORK INSURANCE'
  },
  {
    payerId: 'VTX0707',
    payerName: 'AMERIHEALTH CARITAS NEXT NORTH CAROLINA'
  },
  {
    payerId: 'VTX0708',
    payerName: 'AMERIHEALTH CARITAS NORTH CAROLINA'
  },
  {
    payerId: 'VTX0709',
    payerName: 'AMERIHEALTH CARITAS NORTHEAST'
  },
  {
    payerId: 'VTX0710',
    payerName: 'AMERIHEALTH CARITAS VIP CARE'
  },
  {
    payerId: 'VTX0711',
    payerName: 'AMERIHEALTH PA COMMUNITY HEALTHCHOICES'
  },
  {
    payerId: 'VTX0712',
    payerName: 'AMERITAS LIFE INSURANCE CORPORATION'
  },
  {
    payerId: 'VTX0713',
    payerName: 'ARCHBOLD MEDICAL CENTER'
  },
  {
    payerId: 'VTX0714',
    payerName: 'CARELON BEHAVIORAL HEALTH'
  }
]
